<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="section-icon">credit_card</mat-icon>
      <span i18n="@@Saved Credit Cards">Saved Credit Cards</span>
    </mat-panel-title>
    <mat-panel-description>
      <span *ngIf="profiles.length === 0" i18n="@@No saved cards">No saved cards</span>
      <span *ngIf="profiles.length === 1" i18n="@@1 saved card">1 saved card</span>
      <span *ngIf="profiles.length > 1">{{profiles.length}}&nbsp;<ng-container i18n="@@saved cards">saved cards</ng-container></span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="settings-description" i18n="@@SavedCardsDescription">Manage the credit cards available to you at checkout. The default card is auto-selected when you start a new order. Card numbers are tokenized by our payment gateway; we never store full card numbers or security codes.</div>

  <!-- List of saved cards -->
  <div class="saved-card-list" *ngIf="profiles.length > 0">
    <div *ngFor="let profile of profiles" class="saved-card-row" [class.saved-card-row-default]="profile.default">
      <div class="saved-card-block">
        <div class="saved-card-name">
          <mat-icon class="saved-card-brand-icon">credit_card</mat-icon>
          <span>{{profile.name}}</span>
          <mat-icon *ngIf="profile.default" class="saved-card-default-icon" i18n-title="@@Default" title="Default">favorite</mat-icon>
        </div>
        <div class="saved-card-detail">
          <span *ngIf="profile.cardBrand">{{profile.cardBrand}}&nbsp;</span>
          <span *ngIf="profile.last4">•••• •••• •••• {{profile.last4}}</span>
        </div>
        <div class="saved-card-detail">
          <ng-container *ngIf="profile.expMonth && profile.expYear">
            <ng-container i18n="@@Expires">Expires</ng-container>&nbsp;{{profile.expMonth}}/{{profile.expYear}}
          </ng-container>
          <span *ngIf="profile.cardholderName">&nbsp;—&nbsp;{{profile.cardholderName}}</span>
        </div>
        <div *ngIf="profile.isNotExpired && !profile.isNotExpired()" class="saved-card-expired">
          <mat-icon>warning</mat-icon>&nbsp;<span i18n="@@This card has expired">This card has expired</span>
        </div>
      </div>
      <div class="saved-card-actions">
        <button mat-icon-button *ngIf="!profile.default" (click)="makeDefault(profile)" i18n-title="@@Make default" title="Make default"><mat-icon>favorite_border</mat-icon></button>
        <button mat-icon-button (click)="deleteProfile(profile)" i18n-title="destructive removal|Button that permanently destroys the record. Must be clearly different from Cancel, which only closes a dialog.@@Delete" title="Delete"><mat-icon>delete</mat-icon></button>
      </div>
    </div>
  </div>

  <div class="saved-card-empty" *ngIf="profiles.length === 0 && !showAddCardForm">
    <span i18n="@@No saved cards yet — add one below.">No saved cards yet — add one below.</span>
  </div>

  <!-- Add credit card form -->
  <div class="saved-card-form-wrap" *ngIf="showAddCardForm">
    <h3 class="settings-heading" i18n="@@Add new credit card">Add new credit card</h3>
    <form class="section-form" autocomplete="off">
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-field">
          <mat-label i18n="@@Card nickname">Card nickname</mat-label>
          <input matInput name="formName" [(ngModel)]="formName" i18n-placeholder="@@e.g. Company Visa" placeholder="e.g. Company Visa">
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@First Name">First Name</mat-label>
          <input matInput name="formFirstName" [(ngModel)]="formFirstName" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@Last Name">Last Name</mat-label>
          <input matInput name="formLastName" [(ngModel)]="formLastName" required>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@Credit Card Number">Credit Card Number</mat-label>
          <input matInput name="formCardNumber" [(ngModel)]="formCardNumber" placeholder="**** **** **** ****" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@Expiration">Expiration</mat-label>
          <input matInput name="formExpMonthYear" [(ngModel)]="formExpMonthYear" placeholder="**/**" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@CCV">CCV</mat-label>
          <input matInput name="formCsc" [(ngModel)]="formCsc" placeholder="****" required>
        </mat-form-field>
      </div>

      <h4 class="settings-heading" i18n="@@Billing address">Billing address</h4>
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@Address 1">Address 1</mat-label>
          <input matInput name="formAddress1" [(ngModel)]="formAddress1" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@Address 2">Address 2</mat-label>
          <input matInput name="formAddress2" [(ngModel)]="formAddress2">
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@City">City</mat-label>
          <input matInput name="formCity" [(ngModel)]="formCity" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@State">State</mat-label>
          <mat-select name="formState" [(ngModel)]="formState" required>
            <mat-option *ngFor="let s of usStates" [value]="s.code">{{s.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@Zip Code">Zip Code</mat-label>
          <input matInput name="formPostalCode" [(ngModel)]="formPostalCode" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@Country">Country</mat-label>
          <mat-select name="formCountry" [(ngModel)]="formCountry" required>
            <mat-option *ngFor="let c of countries" [value]="c.code">{{c.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-slide-toggle color="primary" name="formSetAsDefault" [(ngModel)]="formSetAsDefault">
        <ng-container i18n="@@Make this my default payment method">Make this my default payment method</ng-container>
      </mat-slide-toggle>

      <div class="saved-card-error" *ngIf="errorMessage">{{errorMessage}}</div>

      <div class="saved-card-form-actions">
        <button mat-stroked-button type="button" (click)="cancelAddCardForm()" [disabled]="saving" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button color="primary" type="button" [disabled]="!isFormComplete() || saving" (click)="saveCard()">
          <ng-container *ngIf="!saving" i18n="@@Save credit card">Save credit card</ng-container>
          <ng-container *ngIf="saving" i18n="@@Saving">Saving</ng-container>
        </button>
      </div>
    </form>
  </div>

  <!-- Add card CTA (shown when not currently adding) -->
  <div class="saved-card-cta" *ngIf="!showAddCardForm">
    <button mat-raised-button color="primary" (click)="openAddCardForm()">
      <mat-icon>add</mat-icon>&nbsp;<ng-container i18n="@@Add credit card">Add credit card</ng-container>
    </button>
  </div>
</mat-expansion-panel>
